import { makeAutoObservable } from 'mobx';

class FullscreenStore {
  constructor() {
    this.isFullscreen = false;
    this.fullscreenId = 'video-fullscreen-id';
    makeAutoObservable(this);
  }

  setIsFullscreen = (value = false) => {
    this.isFullscreen = value;
  };
}

export default FullscreenStore;
